// extracted by mini-css-extract-plugin
export var banner = "_ie-0";
export var closeButton = "_ie-2";
export var greenCheckmark = "_ie-3";
export var hereLink = "_ie-4";
export var titleIcon = "_ie-1";